module.exports = __webpack_public_path__ + "static/media/frontend_development.83666d05.svg";